import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LocalStorageService } from './localstorage.service';

@NgModule({
  imports: [CommonModule],
  providers: [LocalStorageService]
})
export class UtilsLocalstorageModule {}
